exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".webex-channels .search-bar {\n  max-width: calc(100% + 24px); }\n  .webex-channels .search-bar .search-icon {\n    min-width: 24px; }\n\n.webex-channels .filter-input {\n  max-width: 100%; }\n\n.webex-channels .filter-buttons {\n  display: flex;\n  justify-content: space-between;\n  flex-flow: wrap;\n  padding: 10px 2px; }\n\n.webex-channels .channels {\n  max-height: 350px;\n  min-height: 350px;\n  overflow: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/webex_channels/webex_channels.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/webex_channels/webex_channels.scss
// module chunks = index